function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.22967 1.19148C10.5588 1.19148 13.2688 3.89982 13.2688 7.22898C13.2688 10.5582 10.5588 13.2682 7.22967 13.2682C3.90051 13.2682 1.19217 10.5582 1.19217 7.22898C1.19217 3.89982 3.90051 1.19148 7.22967 1.19148ZM8.11384 5.44648L6.93301 9.62732C6.85301 9.91148 6.81384 10.079 6.81384 10.1323C6.81384 10.1957 6.83217 10.249 6.87051 10.289C6.90801 10.329 6.95384 10.3465 7.00467 10.3465C7.06467 10.3465 7.13551 10.3165 7.21967 10.2515C7.44551 10.074 7.67467 9.81732 7.90551 9.48815L8.11551 9.62565C7.84384 10.039 7.52551 10.3873 7.16051 10.6707C6.88967 10.8807 6.63134 10.9857 6.38467 10.9857C6.22134 10.9857 6.08884 10.9365 5.98551 10.839C5.88134 10.7423 5.82967 10.6198 5.82967 10.474C5.82967 10.3248 5.87967 10.0815 5.97884 9.73982L6.75467 7.06732C6.88134 6.62982 6.94551 6.35565 6.94551 6.24398C6.94551 6.15648 6.91467 6.08482 6.85384 6.02898C6.79134 5.97315 6.70717 5.94565 6.59967 5.94565C6.51217 5.94565 6.33134 5.96732 6.05717 6.01148V5.77898L8.11384 5.44648ZM8.03634 3.31398C8.20301 3.31398 8.34384 3.37148 8.45884 3.48732C8.57634 3.60315 8.63301 3.74398 8.63301 3.91148C8.63301 4.07398 8.57467 4.21398 8.45717 4.33148C8.33884 4.44898 8.19884 4.50732 8.03634 4.50732C7.87301 4.50732 7.73301 4.44898 7.61551 4.33148C7.49717 4.21398 7.43967 4.07398 7.43967 3.91148C7.43967 3.74398 7.49717 3.60315 7.61217 3.48732C7.72801 3.37148 7.86967 3.31398 8.03634 3.31398ZM7.22967 0.333984C3.42051 0.333984 0.333008 3.42065 0.333008 7.22982C0.333008 11.0382 3.42051 14.1257 7.22967 14.1257C11.0388 14.1257 14.1263 11.0373 14.1263 7.22898C14.1263 3.41982 11.0388 0.333984 7.22967 0.333984Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_11569_199)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 -3H-3V17H17V-3Z",
  fill: "#333333"
}));

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11569_199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _ref2), _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.e895996c.svg";
export { ForwardRef as ReactComponent };